import type { PlanogramPegboard } from "@CommonTypes/merchflow/pog/pegboard";
import { PogAtom } from "../../store/types";
import React from "react";
import { Pegboard } from "./Pegboard";
import { getPegboardXLeft } from "../../common/pegboardPosition";

interface Props {
  pegboards: PlanogramPegboard[];
  width: number;
  scaleX: number;
  scaleY: number;
  highlightedItems: string[];
  pogAtom: PogAtom;
}

export const Pegboards = ({
  pegboards,
  width,
  scaleX,
  scaleY,
  highlightedItems,
  pogAtom,
}: Props) => (
  <React.Fragment>
    {pegboards?.map((pegboard, i) => (
      <Pegboard
        key={i}
        pegboard={pegboard}
        pegboardWidth={width}
        xLeft={getPegboardXLeft(pegboard) - pegboard.bay.getXLeft()}
        scaleX={scaleX}
        scaleY={scaleY}
        highlightedItems={highlightedItems}
        pogAtom={pogAtom}
      />
    ))}
  </React.Fragment>
);
